import { render, staticRenderFns } from "./register_users.vue?vue&type=template&id=12641c96&"
import script from "./register_users.vue?vue&type=script&lang=js&"
export * from "./register_users.vue?vue&type=script&lang=js&"
import style0 from "./register_users.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports